export default __webpack_public_path__ + "img/arrow-up.1807c8ae.png";